export default "__VITE_ASSET__CAfZNFEc__"